import React, {useEffect} from "react";
import { Col, Container, Row, Tab, Tabs, Form } from "react-bootstrap";
import style from "../form.module.scss";
import { useKPIs } from "../../../context/KPIsContext";
import { TODIS_FORM_FIELD } from "../../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsArrowClockwise } from "react-icons/bs";
import { TODIS_BTN_SECUNDARY } from "../../../components/Buttons";

const FREIGHT_NPM_KPI = ({data, changeValues, filter, showModalCal}) => {

    const { setValues, values, sumTotal, formatNumber, calculoPromedio, calculoYesNo, calculoPerType } = useKPIs();

    useEffect(() => {
        setValues(prev => {
            return data
        })
    }, [data])

    useEffect(() => {
        calculateKPI()
    }, [values])

    const calculateKPI = () => {
        
        const datas = {
            infrastructure: {
                condition: {
                    veryGood: calculoPerType('condiion', 'Very Good', filter.yearInit),
                    good: calculoPerType('condiion', 'Good', filter.yearInit),
                    medium: calculoPerType('condiion', 'Medium', filter.yearInit),
                    poor: calculoPerType('condiion', 'Poor', filter.yearInit),
                    veryPoor: calculoPerType('condiion', 'Very Poor', filter.yearInit)
                },
                rail_conn: calculoYesNo('rail_conn', filter.yearInit),
                road_conn: calculoYesNo('road_conn', filter.yearInit),
                iww_conn: calculoYesNo('iww_conn', filter.yearInit),
                sea_conn: calculoYesNo('sea_conn', filter.yearInit),
                air_conn: calculoYesNo('air_conn', filter.yearInit),
                req_upgrade_inc_cap: calculoYesNo('req_upgrade_inc_cap', filter.yearInit),
                climateChangeResil: {
                    ch_flood_inci: "",
                    ch_closure_adv_weather_cond : "",
                    ch_embank_fail: ""
                }
            },
            TEN_TCompliance: {
                inter_modality: calculoYesNo('inter_modality', filter.yearInit),
                train_length_740m: calculoYesNo('train_length_740m', filter.yearInit),
                electrified_access: calculoYesNo('electrified_access', filter.yearInit),
                open_availability: calculoYesNo('open_availability', filter.yearInit)
            },
            operations: {
                storage_capacity_used: calculoPromedio('storage_capacity_used', filter.yearInit),
                trsnshipment_capacity_used: calculoPromedio('trsnshipment_capacity_used', filter.yearInit)
            },
            maintenance: {
                maint_cost_total_py: formatNumber(sumTotal('maint_cost_total_py', filter.yearInit)), 
                emergency_cost_py: formatNumber(sumTotal('emergency_cost_py', filter.yearInit)), 
                routine_cost_py: formatNumber(sumTotal('routine_cost_py', filter.yearInit)) 
            },
            environmentalImpact: {
                co2_ems: formatNumber(sumTotal('co2_ems', filter.yearInit)),
                nox_ems: formatNumber(sumTotal('nox_ems', filter.yearInit)),
                so2_ems: formatNumber(sumTotal('so2_ems', filter.yearInit)),
                nmhc_ems: formatNumber(sumTotal('nmhc_ems', filter.yearInit)),
                ppm: formatNumber(sumTotal('ppm', filter.yearInit))
            }
        }

        changeValues(datas)
    }
    
    return (
        <Tabs defaultActiveKey="Infrastructure" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">
            <Tab eventKey="Infrastructure" title="Infrastructure" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div style={{borderBottom: "3px solid #004494"}}>
                                <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Condition</Form.Label>
                            </div>
                            <Row style={{paddingTop: "15px"}}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.condition.veryGood" label="% Very Good" name="infrastructure.condition.veryGood" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.condition.good" label="% Good" name="infrastructure.condition.good" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.condition.medium" label="% Medium" name="infrastructure.condition.medium" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.condition.poor" label="% Poor" name="infrastructure.condition.poor" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.condition.veryPoor" label="% Very Poor" name="infrastructure.condition.veryPoor" disabled={true}/>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="infrastructure.rail_conn" label="Rail Connection" name="infrastructure.rail_conn" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="infrastructure.road_conn" label="Road Connection" name="infrastructure.road_conn" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="infrastructure.iww_conn" label="IWW Connection" name="infrastructure.iww_conn" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="infrastructure.sea_conn" label="Sea Connection" name="infrastructure.sea_conn" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="infrastructure.air_conn" label="Air Connection" name="infrastructure.air_conn" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="infrastructure.req_upgrade_inc_cap" label="Upgrading Requirements" name="infrastructure.req_upgrade_inc_cap" disabled={true}/>
                        </Col>
                        <Col lg={12}>
                            <div style={{borderBottom: "3px solid #004494"}}>
                                <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Climate Change Resilience</Form.Label>
                            </div>
                            <Row style={{paddingTop: "15px"}}>
                                <Col lg={5}>
                                    <TODIS_FORM_FIELD id="infrastructure.climateChangeResil.ch_flood_inci" label="Number of flooding incidents per 100km" name="infrastructure.climateChangeResil.ch_flood_inci" disabled={true}/>
                                </Col>
                                <Col lg={1}>
                                    <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCal("infrastructure.climateChangeResil.ch_flood_inci", "ch_flood_inci")}/>
                                </Col>
                                <Col lg={5}>
                                    <TODIS_FORM_FIELD id="infrastructure.climateChangeResil.ch_closure_adv_weather_cond" label="Number of closures due to adverse weather conditions per 100km" name="infrastructure.climateChangeResil.ch_closure_adv_weather_cond" disabled={true}/>
                                </Col>
                                <Col lg={1}>
                                    <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCal("infrastructure.climateChangeResil.ch_closure_adv_weather_cond", "ch_closure_adv_weather_cond")}/>
                                </Col>
                                <Col lg={5}>
                                    <TODIS_FORM_FIELD id="infrastructure.climateChangeResil.ch_embank_fail" label="Number of embankment failures per 100km" name="infrastructure.climateChangeResil.ch_embank_fail" disabled={true}/>
                                </Col>
                                <Col lg={1}>
                                    <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCal("infrastructure.climateChangeResil.ch_embank_fail", "ch_embank_fail")}/>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="TENT_T" title="TENT-T Compliance" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.inter_modality" label="Inter-modality" name="TEN_TCompliance.inter_modality" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.train_length_740m" label="740m train length" name="TEN_TCompliance.train_length_740m" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.electrified_access" label="Electrified access" name="TEN_TCompliance.electrified_access" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.open_availability" label="Open availability" name="TEN_TCompliance.open_availability" disabled={true}/>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="operations" title="Operations" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="operations.storage_capacity_used" label="Storage capacity utilisation rate" name="operations.storage_capacity_used" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="operations.trsnshipment_capacity_used" label="Transhipment capacity utilisation rate" name="operations.trsnshipment_capacity_used" disabled={true}/>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="maintenance" title="Maintenance" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.maint_cost_total_py" label="Maintenance Cost Total" name="maintenance.maint_cost_total_py" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.emergency_cost_py" label="Emergency Maintenance Cost" name="maintenance.emergency_cost_py" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.routine_cost_py" label="Routine Maintenance Cost" name="maintenance.routine_cost_py" disabled={true}/>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="environmentalImpact" title="Environmental Impact" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="environmentalImpact.co2_ems" label="CO2 emissions" name="environmentalImpact.co2_ems" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="environmentalImpact.nox_ems" label="NOx emissions" name="environmentalImpact.nox_ems" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="environmentalImpact.so2_ems" label="SO2 emission evolution" name="environmentalImpact.so2_ems" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="environmentalImpact.nmhc_ems" label="Non-methane hydrocarbons" name="environmentalImpact.nmhc_ems" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="environmentalImpact.ppm" label="Particulate matter (ppm)" name="environmentalImpact.ppm" disabled={true}/>
                        </Col>
                    </Row>
                </Container>
            </Tab>
        </Tabs>
    )
}

export default FREIGHT_NPM_KPI;